import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
// validator
import isNumeric from "validator/lib/isNumeric";
import useStyles from "./styles";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormNumber({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  isSubmitting,
  pk,
  subformIndex,
  handleBackSub,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [jawaban, setJawaban] = useState(value.jawaban || 0);

  useEffect(() => {
    setError({});
  }, []);

  const { pertanyaan, definisi_operasional } = form;

  const handleChange = (e) => {
    if (e.target.type === "number" && parseInt(e.target.value) < 0) {
      return false;
    }
    if (e.target.name === "jawaban" && e.target.value.length > 5) {
      return false;
    }

    if (parseInt(form.no) === 23 && parseInt(e.target.value) > 10000) {
      return false;
    }

    if (parseInt(form.no) === 24 && parseInt(e.target.value) > 100) {
      return false;
    }

    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "jawaban":
        setJawaban(e.target.value);
        break;
      default:
        break;
    }

    // setSomethingChange(true)
  };

  // console.log("number");

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: 0,
      // Jawaban_H1: jawaban == '' ? 0 : parseInt(jawaban),
      Jawaban_H1: jawaban == "" ? 0 : jawaban,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: value.jawaban_lainnya ? value.jawaban_lainnya : "",
    };

    if (value._rev) {
      normalizeValue._rev = value._rev;
    }

    saveChangeValue(normalizeValue);
  }, [jawaban]);

  const validate = () => {
    let newError = {};

    if (!value.jawaban) {
      newError.jawaban = "Wajib diisi";
    } else if (!isNumeric(value.jawaban)) {
      newError.jawaban = "Jawaban tidak valid";
    } else if (parseInt(form.no) === 20 && +value.jawaban < 4) {
      newError.jawaban = "Jawaban lebih besar dari 3";
    } else if (parseInt(form.no) === 23 && +value.jawaban === 0) {
      newError.jawaban = "Jawaban lebih besar dari 0";
    } else if (parseInt(form.no) === 24 && +value.jawaban === 0) {
      newError.jawaban = "Jawaban lebih besar dari 0";
    }

    return newError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: 0,
        // Jawaban_H1: jawaban == '' ? 0 : parseInt(jawaban),
        Jawaban_H1: jawaban == "" ? 0 : jawaban,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya ? value.jawaban_lainnya : "",
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      saveValue(normalizeValue);
      // console.log("NORMALIZE VALUE PK N0.20 >>>>> ", normalizeValue);
    }
  };

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>{form.no}</span>
              {form.pertanyaan}
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                title={`Pertanyaan ${form.no}`}
                content={definisi_operasional}
              />
            </div>
          </div>

          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} md={3}>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="jawaban"
                  name="jawaban"
                  value={value.jawaban || ""}
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        className={classes.inputAdornmentNoWrap}
                        position="end"
                      >
                        {form.unit}
                      </InputAdornment>
                    ),
                  }}
                  type="number"
                  inputProps={{
                    className: classes.inputMini,
                    min: 0,
                    maxLength: 5,
                  }}
                  error={error.jawaban ? true : false}
                  helperText={error.jawaban}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormNumber;
